export default __webpack_public_path__ + "img/3592e588161376a1b053cdee844b71ba.png";